import React from "react";
import { Link } from "react-router-dom"; // Navigation ke liye
import './footer.css';
import footerLogo from '../../assets/images/Footer/header-logo-light.png';

export default function Footer() {
  return (
    <footer className="footer pt-5 pb-3 bg-dark text-light">
      <section className="container-fluid container-xl">

        {/* Main Footer Content */}
        <div className="row py-5 gy-4">
          {/* Brand & SEO Description */}
          <div className="col-12 col-lg-4 text-center text-lg-start">
            <img src={footerLogo} alt="Chiller Fleet - Refrigerated Transport Dubai & UAE" className="mb-3 img-fluid" style={{maxWidth: '200px'}} />
            <p className=" py-4 text-light">
              Chiller Fleet Transport is a leading provider of <strong>refrigerated transport solutions</strong> in Dubai, Abu Dhabi, Sharjah, & UAE. We specialize in <strong>Chiller Van Rental</strong> and <strong>Freezer Trucks</strong> to keep your goods fresh.
            </p>
            <div className="d-flex justify-content-center justify-content-lg-start gap-3 mt-3">
              <a href="https://www.facebook.com/people/Chiller-Fleet-Rental/61584466431433/" className="social-icon" aria-label="Facebook"><i className="bi bi-facebook"></i></a>
              <a href="https://www.instagram.com/chillerfleet.1/" target="_blank" className="social-icon" aria-label="Instagram"><i className="bi bi-instagram"></i></a>
              <a href="https://www.linkedin.com/company/chiller-fleet-transport/" className="social-icon" aria-label="LinkedIn"><i className="bi bi-linkedin"></i></a>
              <a href="https://www.tiktok.com/@chiller.fleet?_r=1&_t=ZS-95ElkFiaxQO" className="social-icon" aria-label="TikTok"><i className="bi bi-tiktok"></i></a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-6 col-md-3 col-lg-2">
            <h3 className="fw-bold mb-4">Company</h3>
            <ul className="list-unstyled footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/services">Our Services</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
            </ul>
          </div>

          {/* Top Services (SEO Focused) */}
          <div className="col-6 col-md-3 col-lg-3">
            <h3 className="fw-bold mb-4">Our Services</h3>
            <ul className="list-unstyled footer-links">
              <li><Link to="/services">All Services</Link></li>
              <li><Link to="/chiller-van-for-rent">Chiller Van for Rent</Link></li>
              <li><Link to="/chiller-truck-for-rent">Chiller Truck for Rent</Link></li>
              <li><Link to="/refrigerated-trucks-for-rent">Refrigerated Trucks for Rent</Link></li>
              <li><Link to="/freezer-van-for-rent">Freezer Van for Rent</Link></li>
              <li><Link to="/freezer-truck-for-rent">Freezer Truck for Rent</Link></li>
              <li><Link to="/high-roof-dry-van-for-rent">High Roof Dry Van for Rent</Link></li>
              <li><Link to="/truck-rental-in-fujairah">Truck Rental in Fujairah</Link></li>
              <li><Link to="/van-rental-in-dubai">Van Rental in Dubai</Link></li>
              <li><Link to="/chiller-van-for-rent-in-sharjah">Chiller Van for Rent in Sharjah</Link></li>
              <li><Link to="/chiller-van-for-rent-in-abu-dhabi">Chiller Van for Rent in Abu Dhabi</Link></li>
            </ul>
          </div>

          {/* Additional Services (Optional/SEO) */}
          <div className="col-12 col-md-6 col-lg-3">
            <h3 className="fw-bold mb-4">Contact Info</h3>
            <p className="mb-2 text-light"><i className="bi bi-clock me-2"></i>Available 24/7 for Transport</p>
            <p className="mb-2 text-light"><i className="bi bi-patch-check me-2"></i>Licensed Refrigerated Carrier</p>
            <p><a href="tel:+971 54 479 2905" className="mb-2 text-light text-decoration-none"><i className="bi bi-telephone-fill me-2"></i>+971 54 479 2905</a></p>
            <p><a href="mailto:info@chillerfleet.com" className="mb-2 text-light text-decoration-none"><i className="bi bi-envelope-fill  me-2"></i>info@chillerfleet.com</a></p>
            <p className="mb-2 text-light text-decoration-none"><i className="bi bi-geo-alt-fill me-2"></i>Ras Al Khor Industrial Area 1- Dubai - UAE</p>
          </div>
        </div>

        {/* Copyright */}
        <div className="row pt-3 border-top border-secondary">
          <div className="col-12 text-center">
            <p className="text-light mb-0">
              © {new Date().getFullYear()} <strong>Chiller Fleet Transport</strong>.    
              Design and SEO by{" "}
              <a 
                href="https://wa.me/923085703803"  
                target="_blank" 
                rel="noopener noreferrer" style={{ textDecoration: "none" }}
              >
                Swatnik Solutions
              </a>{" "}
       
      </p>
           
          </div>
        </div>
      </section>

{/* Call Floating Button */}
<a 
  href="tel:+971544792905" 
  className="call-float" 
  aria-label="Call us"
>
  <i className="bi bi-telephone-fill"></i>
</a> 
      {/* WhatsApp Floating Button */}
      <a href="https://wa.me/971544792905" 
         className="whatsapp-float" 
         target="_blank" 
         rel="noopener noreferrer"
         aria-label="Chat on WhatsApp">
        <i className="bi bi-whatsapp"></i>
      </a>
    </footer>
  );
}